export const OPTION_TYPE_FIELD = 'customSelectOptionType';
// this is to show the subtitle like offering/One-time (subheading)
export const CUSTOM_SELECT_SUBTITLE_TYPE = 'subtitle';
